const SITE_URL: string = import.meta.env.VITE_SITE_URL || "";
const SITE_NAME = "USFanslink";
const SITE_DESCRIPTION =
  "Explore the USFans Spreadsheet with creator resources, reviews, shipping information, coupons, guides and updates.";
const LOGO_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

export function siteUrl(path: string): string {
  return `${SITE_URL}${path}`;
}

export function websiteJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    inLanguage: "en",
  };
}

export function organizationJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: LOGO_URL,
  };
}

export function articleJsonLd(opts: {
  headline: string;
  description: string;
  image?: string;
  url: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: opts.headline,
    description: opts.description,
    image: opts.image ? [opts.image] : undefined,
    datePublished: "2026-08-23",
    dateModified: "2026-08-23",
    author: { "@type": "Organization", name: SITE_NAME },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: { "@type": "ImageObject", url: LOGO_URL },
    },
    mainEntityOfPage: opts.url,
  };
}